import React from 'react';
import { useTranslation } from 'react-i18next';

import { SONAR_PROJECT_RANGE_TYPE } from '../../../constants';
import dayjs, { DATE_FORMATS } from '../../../utils/dateUtils';

import scss from './ProjectCard.module.scss';

function SonarCardDate({ collectedFrom, collectedTill, rangeType }) {
  const {
    t,
    i18n: { language },
  } = useTranslation('projects');

  const dailyFormatter = (date) => dayjs(date, DATE_FORMATS.API_DATE).format(DATE_FORMATS.DAILY_FORMAT);
  const monthlyFormatter = (date) =>
    dayjs(date, DATE_FORMATS.API_DATE).locale(language).format(DATE_FORMATS.MONTHLY_FORMAT);

  const formattedCollectedFrom =
    rangeType === SONAR_PROJECT_RANGE_TYPE.MONTHLY_RANGE
      ? monthlyFormatter(collectedFrom)
      : dailyFormatter(collectedFrom);

  const formattedCollectedTill =
    rangeType === SONAR_PROJECT_RANGE_TYPE.MONTHLY_RANGE
      ? monthlyFormatter(collectedTill)
      : dailyFormatter(collectedTill);

  return (
    <div className={scss.rowInfo}>
      <span className={scss.textCommon}>{t('dataCollected')}:</span>
      <span className={scss.textStressed}>
        {formattedCollectedFrom === formattedCollectedTill
          ? formattedCollectedFrom
          : formattedCollectedFrom + ' - ' + formattedCollectedTill}
      </span>
    </div>
  );
}

export default SonarCardDate;
